import { FC } from 'react';
import { FormikHelpers } from 'formik';
import classNames from 'classnames';
import { ButtonOutlinePrimary, Form, InputText, useSnackbar } from '@lambdacurry/component-library';
import { useAddDiscountCodeToCartMutation, useCurrentCartQuery } from 'lib/home/generated/queries';
import { MedusaDiscount } from 'lib/home/generated/types/api';

export interface CartPromoCodeFormProps {
  onPromoCodeApplied?: (discounts: MedusaDiscount[]) => void;
}

const initialValues = { discount_code: '' };
type FormValues = typeof initialValues;

export const CartPromoCodeForm: FC<CartPromoCodeFormProps> = ({ onPromoCodeApplied }) => {
  const { addSnackbar } = useSnackbar();
  const { mutate } = useAddDiscountCodeToCartMutation();
  const currentCartQuery = useCurrentCartQuery();

  const handleSubmit = (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
    mutate(
      { addDiscountCodeInput: { code: values.discount_code } },
      {
        onSuccess: ({ addDiscountCodeToCart }) => {
          formikHelpers.resetForm();
          currentCartQuery.refetch();
          addSnackbar(`Promo code "${values.discount_code}" applied!`, { variant: 'success' });
          if (onPromoCodeApplied) onPromoCodeApplied(addDiscountCodeToCart);
        },
        onError: () => formikHelpers.resetForm()
      }
    );
  };

  return (
    <Form<FormValues> initialValues={initialValues} onSubmit={handleSubmit}>
      {formikProps => (
        <div className="flex mb-2">
          <div className="flex-1">
            <InputText name="discount_code" label="Promo Code" />
          </div>
          <ButtonOutlinePrimary
            className={classNames('mt-4', { 'pointer-events-none': !formikProps.dirty || formikProps.isSubmitting })}
            type="submit"
            data-cy="apply-discount-code"
            disabled={!formikProps.dirty || formikProps.isSubmitting}
          >
            Apply
          </ButtonOutlinePrimary>
        </div>
      )}
    </Form>
  );
};
